const Arrow = ({ onClick, style, size = "8rem", ...extraProps }) => {
  return (
    <div
      style={{
        ...styles.arrowContainer,
        justifyContent: "flex-start",
        cursor: onClick == undefined ? "default" : "pointer",
        ...extraProps,
        width:size,
        height:size,
      }}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      <img
        src={onClick == undefined ? "/assets/icons/bar.svg" : "/assets/icons/arrow.svg"}
        style={style}
      />
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  arrowContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
  },
};

export default Arrow;
